import ModalLanguage from '@/components/Modal/Language';
import ModalLogin from '@/components/Modal/Login';
import ModalRegister from '@/components/Modal/Register';
import ModalForgetPassword from '@/components/Modal/ForgetPassword';

const Modal = {
    install (Vue) {
        this.EventBus = new Vue();
        Vue.component('ModalLanguage', ModalLanguage);
        Vue.component('ModalLogin', ModalLogin);
        Vue.component('ModalRegister', ModalRegister);
        Vue.component('ModalForgetPassword', ModalForgetPassword);

        //Auto1 Modal
        const PPlusModal = {
            language() {
                Modal.EventBus.$emit('showLanguage');
            },
            login() {
                Modal.EventBus.$emit('showLogin');
            },
            register() {
                Modal.EventBus.$emit('showRegister');
            },
            forgetPassword() {
                Modal.EventBus.$emit('showForgetPassword');
            }
        };

        Vue.prototype.$PPlusModal = PPlusModal;
    }
}

export default Modal;